<template>
  <div class="g col-12 col-lg-6 c">
    <br>
    <div class="card">
        <div class="card-header">
            طباعة نموذج الالتزام المدرسي
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-lg-6 g">
                    <div class="form-group">
                      <label for="">اسم المدرسة</label>
                      <input type="text"
                        class="form-control" v-model="school_name" placeholder="اكتب هنا...">
                    </div>
                </div>
                <div class="col-12 col-lg-6 g">
                    <div class="form-group">
                      <label for="">المنطقة/المحافظة</label>
                      <input type="text"
                        class="form-control" v-model="gover" placeholder="اكتب هنا...">
                    </div>
                </div>
            </div>
            <div>
                <p>اختر المراد الطباعة لهم</p>
                <div class="row">
                    <div class="col-12 col-lg-6 g">
                        <button class="btn btn-block btn-primary" @click="way = 'single'">
                            <i class="fa fa-users"></i>
                            اختر فردياً
                        </button>
                    </div>
                    <div class="col-12 col-lg-6 g">
                        <button class="btn btn-block btn-success" @click="way = 'bulk'">
                            <i class="fa fa-users"></i>
                            اختر من الفصول
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="way == 'single' || way == 'attend'">
                <div class="g">
                    اختر الطلاب
                </div>
                <div style="width: 100%; border: solid 2px #333; padding: 5px; overflow-y: scroll; height: 250px;">
                    <div class="form-check" v-for="student in students" :key="student._id">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                        {{ student.name }}
                    </label>
                    </div>
                </div>
            </div>
            <div v-if="way == 'bulk'">
                <div>
                    اختر الفصول <a href="javascript:;" @click="xxxc()">
                        <i class="fa fa-check-square"></i>
                        اختيار الكل
                    </a>
                    <br><br>
                </div>
                <div class="form-check" v-for="c in classrooms" :key="c">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input ascddsd" @change="classChanges(c)" v-model="selected_classrooms" :value="c">
                        {{ c }}
                    </label>
                    <div class="card-body">
                        <div class="border g" style="overflow-y: scroll; height: 100px">
                            <template v-for="student in students">
                                <div v-if="student.row_name == c" class="form-check" :key="student._id">
                                    <label class="form-check-label">
                                        <input type="checkbox" class="form-check-input" v-model="selected" :value="student">
                                        {{ student.name }}
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer" v-if="way && selected.length > 0">
                <div class="row">
                    <div class="col-12 col-lg-6 g c">
                        <button class="btn btn-success btn-block" @click="sendd=false;print()">
                            <i class="fa fa-print"></i>
                            طباعة النموذج
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            type: window.location.href.split("type=")[1].split("&")[0],
            school_id: window.location.href.split("school_id=")[1].split("&")[0],
            message: `اسم الطالب: {name}
الفصل: {class}
الجوال: {phone}
الايميل: {email}`,
            students: [],
            loading: false,
            view_archive: false,
            selected_classroom: "all",
            selected_classrooms: [],
            classrooms: [],
            selected: [],
            gover: "",
            school_name: "",
            way: false,
            q: null,
        }
    },
    created(){
      var g = this;
      var school_id = g.school_id
      setTimeout(() => {
        $("#date").html(new Date().toISOString().split('T')[0])
        $("body").append(`
          <textarea class='get-local-storage' name='${g.type}_students_${school_id}'></textarea>
        `)
        var i1 = setInterval(() => {
            if($(`.get-local-storage-value[name='${g.type}_students_${school_id}']`).length){
              clearInterval(i1)
              g.students = JSON.parse($(`.get-local-storage-value[name='${g.type}_students_${school_id}']`).val())
              var v = []
              g.students.forEach(element => {
                element.show = true
                element.message = ""
                if(!g.classrooms.includes(element.row_name)){
                  g.classrooms.push(element.row_name)
                }
                v.push(element)
              });
              g.students = v
            }
        }, 10);
      }, 500);
    },
    methods: {
        
        print(){
            var g = this;
            var html = "";
            var win = window.open("");
            g.selected.forEach(function(bi){
            html = html + (`
                <div class='container'>
                <div class="row" style='padding-top: 10px'>
                    <div class="col-4 text-center">
                    <p><Br><Br>
                        المملكة العربية السعودية
                        <br>
                        وزارة التعليم
                    </p>
                    </div>
                    <div class="col-4 text-center"><br>
                    <img style="width: 150px !important;" src="https://cdn-static.brmja.com/storage/scrapped/62793ceb03c19132886968.jpg">
                    </div>
                    <div class="col-4 text-center"><br><Br>
                    <p style='padding-top: 5px'>
                    المنطقة/المحافظة: ${g.gover}
                    <br>
                    المدرسة: ${g.school_name}
                    </p>
                    </div>
                    <div class='col-12 text-center'>
                    <h4>نموذج الالتزام المدرسي</h4>
                    <br>
                    </div>
                    <div class='col-12'>
                        <table class='table table-bordered table-lg'>
                            <tbody>
                                <tr>
                                    <td style='padding: 10px'>
                                        <br><Br>
                                        خاص <br>
                                        بالطالب / الطالبة
                                    </td>
                                    <td style='padding: 10px'>
                                        الاسم: ${bi.name}
                                        <br><br>
                                        الصف: ${bi.class_name}
                                        <br><br><br>
                                        <p>نعم أنا الطالب/الطالبة الموضح اسمه وبياناته أعلاه. قد اطلعت على محتوى قواعد السلوك والمواظبة، وبناء عليه أتعهد أن ألتزم بالأنظمة والتعليمات الخاصة بقواعد السلوك والمواظبة.</p>
                                        التوقيع: .................................................
                                        &nbsp;&nbsp; التاريخ :  &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; 14 هـ
                                    </td>
                                </tr>
                                <tr>
                                    <td style='padding: 10px'>
                                        <br><Br>
                                        خاص بولي الأمر
                                    </td>
                                    <td style='padding: 10px'>
                                        <p>
                                        نعم أنا ولي أمر الطالب/الطالبة الموضح اسمه وبياناته أعلاه. قد اطلعت على محتوى قواعد السلوك والمواظبة، وبناء عليه أتعهد أن أتعاون مع إدارة المدرسة في سبيل مصلحة ابني/ابنتي، ليكون ملتزماً بالأنظمة والتعليمات الخاصة بقواعد السلوك والمواظبة، وأتحمل مسؤولية صحة أرقام التواصل التالية:
                                        </p>
                                        الاسم: .................................................
                                        <br><br>
                                        التوقيع: ................................................. 
                                        &nbsp;&nbsp;
                                        التاريخ :  &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp; 14 هـ
                                        <br><br>
                                        العمل: .................................................
                                        &nbsp;&nbsp;
                                        هاتف العمل: .................................................
                                        <br><br>
                                        هاتف المنزل: .................................................
                                        &nbsp;&nbsp;
                                        رقم الجوال: .................................................
                                        <br><br>
                                        رقم آخر: .................................................
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class='col-12' style='padding: 10px'></div>
                    <div class='col-6' style='position:relative'>
                        ملحوظة:
                        <Br>
                        <ul>
                            <li>يؤخذ توقيع الطالب وولي الأمر في بداية العام الدراسي.</li>
                            <li>تحفظ النماذج في ملف خاص لدى وكيل/وكيلة شؤون الطلبة.</li>
                        </ul>
                        <img src='https://app.naqar.net/bis-qrcode.png' style='position: absolute; left: -250px;top: -20px; width: 200px'>
                    </div>
                </div>
                </div>
            `)
                
            })
            win.document.write(`
            <html dir="rtl">
                <head>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css">
                <style>
                    .bg-dark{
                    background: #DDDDDD !important
                    }
                        .container{
                        page-break-after:always;
                        }
                        @media print {
                        @page {
                        margin: 0;
                    }
                        .print{display:none}}
                        @page {
                        margin: 0;
                    }
                    @media print {
                    @page {
                        margin: 0 !important;
                        padding: 0px;
                    }
                    }
                </style>
                </head>
                <body>
                ${html}
                </body>
            </html>
            `)
            win.document.close()
            setTimeout(() => {
                win.print()
            }, 1000);
            win.document.designMode = "on"
        },
        xxxc(){
            $(".ascddsd").each(function(){
                $(this).click()
            })
        },  
        classChanges(cc){
            var g = this;
            g.students.forEach(function(a){
                if(g.selected_classrooms.includes(a.row_name) && cc == a.row_name){
                    g.selected.push(a)
                }
                if(!g.selected_classrooms.includes(a.row_name)){
                    g.selected = g.selected.filter(function(x){
                        if(!g.selected_classrooms.includes(x.row_name)){
                            return false;
                        }else{
                            return x;
                        }
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>